module.exports = __webpack_public_path__ + "assets/img/s13.38e7f24c.png";